// Module
var code = "<div class=\"information\"> <div class=\"information-icon\"> <icon name=\"info\" style=\"font-size:32px\"></icon> </div> <div class=\"information-text\" v-html=\"text\"></div> <a href=\"#\" @click.prevent.stop=\"close\" ref=\"closeButtonEl\" class=\"close-dialog\" aria-label=\"Close dialog\"> <icon name=\"close\"></icon> </a> </div> ";
// Exports
export default code;